export function getproductadaptour(productmodel) {
  var arrayliveproductflat = [];
  productmodel.data.forEach((element) => {
    var productdata = {
      product: {
        title: element.title,
        productId: element.id,
        handle: element.handle,
        sku: element.variants[0]?.sku,
        image: element.images[0]?.src,
        productTitle: element.title,
        productLink: element.handle,
        productSku: element.variants[0]?.sku,
        imageUrl: element.images[0]?.src,
        variants: element.variants,
        // Set by the backend only for an ACTIVE campaign whose product is
        // (partly) held by another live campaign. The popover lists the whole
        // scope and marks these instead of dropping them.
        heldVariantCount: element.heldVariantCount ?? 0,
        scopeVariantCount: element.scopeVariantCount ?? element.variants?.length ?? 0,
        heldByCampaignName: element.heldByCampaignName ?? null,
        heldByCampaignCount: element.heldByCampaignCount ?? 0,
      },
    };
    arrayliveproductflat.push(productdata);
  });
  return {
    data: {
      success: true,
      data: {
        id: '',
        status: 1,
        liveProducts: arrayliveproductflat,
      },
    },
  };
}
